import { Component, OnInit , ViewChild} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { RoutingService } from '../../services/routing.service';
import { RestapiService } from '../../services/restapi.service';

@Component({
  selector: 'app-game-resources',
  templateUrl: './game-resources.component.html',
  styleUrls: ['./game-resources.component.scss']
})
export class GameResourcesComponent implements OnInit {

  title: string;
  url: string;
  game: any;
  categories: any;
  cont: any;
  blog: any;
  private routeObs: Subscription;


  constructor(
    private activatedRoute: ActivatedRoute,
    public route: RoutingService,
    public api: RestapiService
  ) {

    this.routeObs = this.route.onRouteChange.subscribe(res => {
      console.log('routeObs change')
      setTimeout(() => {
        this.route.setCurrent(window.location.pathname);
        this.loadContent();
      }, 10);
    });
  }

  ngOnInit(): void {
    this.loadContent()
  }

  loadContent() {


    this.url = this.activatedRoute.snapshot.paramMap.get('url');
 /*    this.api.getdata('webresource', {
      filters: { webcontext_id: { value: this.url } }
    }).subscribe(res => {
      if (res.status == true) {
        console.log('CURRENT WEB RESOURCES', res);
        this.blog = res.result.data;
      }
      else {
        console.log('ERROR ON LOAD', this.url);
      }
    })
 */

    this.url = this.activatedRoute.snapshot.paramMap.get('game');
    switch (this.url) {
      case 'incendios-forestales':
        this.title = 'Incendios Forestales';
        this.api.getdata('webresource', { filters: {
      //    webroute_id: { value: 9 } ,
          webcontext_id: { value: 12 } ,
        } })
        .subscribe(res=>{
          if (res.status == true) {
            console.log('CURRENT WEB RESOURCES', res);
            this.blog = res.result.data;
          }
          else {
            console.log('ERROR ON LOAD', this.url);
          }
        })
        break;
      case 'humedales':
        this.title = 'Humedales';
        this.api.getdata('webresource', { filters: {
      //    webroute_id: { value: 9 } ,
          webcontext_id: { value: 13 } ,
        } })
        .subscribe(res=>{
          if (res.status == true) {
            console.log('CURRENT WEB RESOURCES', res);
            this.blog = res.result.data;
          }
          else {
            console.log('ERROR ON LOAD', this.url);
          }
        })
        break;
    }


  }

}
